<template>
    <MicroAppProItemPage />
</template>

<script setup lang="ts">
import MicroAppProItemPage from '~/components/micro-app/MicroAppProItemPage.vue'
</script>
